import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "./cartSlice";
import scrollSlice from "./scrollSlice";
import resSlice from "./resSlice";
import { loadState, saveState } from "../localStorage";

const preloadedState = loadState();

const store = configureStore({
	reducer: {
		cart: cartSlice,
		scroll: scrollSlice,
		res: resSlice,
	},
	preloadedState
});

store.subscribe(() => {
	saveState(store.getState());
});

export { store };